export enum OrderEnum {
  next = 'next',
  prev = 'prev',
}

export interface PaginationInterface {
  startFromId?: number | string
  order: OrderEnum
  staticUrl?: boolean
}

export type LimitObjType = Record<'short' | 'medium' | 'long', number>

export interface SwrPaginationInterface {
  limit?: number
  pagination: PaginationInterface
}
